module.exports = __webpack_public_path__ + "static/media/Lafayette Cam 04.12cedb2c.webp";